module.exports = __webpack_public_path__ + "img/successfull.3f87438a.png";